import { FunctionComponent } from 'react';
import { Option } from '@spike/model';
import { Chip } from 'components/UI/V3/Chip/Chip';
import clsx from 'clsx';
import styles from './Status.module.scss';

interface Props {
    status: Option<string>;
}

export const Status: FunctionComponent<Props> = ({ status }) => {
    return (
        <div
            className={clsx(styles.root, {
                [styles.inStock]: status.id === 'in_stock',
                [styles.lowStock]: status.id === 'low_stock',
                [styles.critical]: status.id === 'out_of_stock' || status.id === 'expired'
            })}
        >
            <Chip label={status.name} />
        </div>
    );
};

export default Status;
